export const loadGoogleMapsScript = (apiKey) => {
  return new Promise((resolve, reject) => {
    // If Google Maps already loaded
    if (window.google && window.google.maps) {
      resolve(window.google);
      return;
    }

    // If script already in progress of loading
    const existingScript = document.querySelector(
      `script[src^="https://maps.googleapis.com/maps/api/js"]`
    );
    if (existingScript) {
      existingScript.addEventListener("load", () => resolve(window.google));
      existingScript.addEventListener("error", reject);
      return;
    }

    // Create script
    const script = document.createElement("script");
    script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places&loading=async`;
    script.async = true;
    script.defer = true;

    script.onload = () => resolve(window.google);
    script.onerror = (err) => reject(err);

    document.head.appendChild(script);
  });
};
